import SortableList from './container';

export default SortableList;
